var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.83,
    height: 17.83,
    viewBox: "0 0 17.83 17.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_input_periodo_calendario",
    "data-name": "icona input periodo/calendario",
    d: "M15.92,1.91h-1.91V.637a.637.637,0,1,0-1.274,0V1.91H5.094V.637a.637.637,0,1,0-1.274,0V1.91H1.91A1.91,1.91,0,0,0,0,3.821v12.1a1.91,1.91,0,0,0,1.91,1.91H15.92a1.91,1.91,0,0,0,1.91-1.91V3.821A1.91,1.91,0,0,0,15.92,1.91Zm.637,14.009a.637.637,0,0,1-.637.637H1.91a.637.637,0,0,1-.637-.637V7.641H16.556Zm0-9.552H1.274V3.821a.637.637,0,0,1,.637-.637h1.91V4.457a.637.637,0,1,0,1.274,0V3.184h7.641V4.457a.637.637,0,1,0,1.274,0V3.184h1.91a.637.637,0,0,1,.637.637V6.368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ccdd40f99a1a40b55d6c1f03eac4828a.svg";
export { ForwardRef as ReactComponent };